<template>
  <div class="tabs-wrapper" :class="{ ready: dataReady }" :style="finalStyle">
    <div v-if="loading" class="loading">
      <van-loading size="24px" />
    </div>
    <van-tabs v-show="tags.length" v-model:active="active" sticky :offset-top="pagePaddingTop" title-active-color="#333"
      title-inactive-color="#333" :before-change="beforeTabChange" @scroll="onTabsScroll">
      <van-tab v-for="item in tags" :title="item.title" :name="item.type + '-' + item.value">
        <goods-list :value="item.value" />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue';
import { getCache, setCache } from '@voghion/native-api'
import { getContentTagList } from '@/api/content'
import GoodsList from './GoodsList.vue'
import { revertWindowScrollTop } from '@/utils/cache'
import { nextTick } from 'vue';
import { getScrollTop } from '@voghion/fe-util';
import { computed } from 'vue';
import { useEnvStore } from '@/states/env'
import { storeToRefs } from 'pinia'

const store = useEnvStore()
const { pagePaddingTop } = storeToRefs(store)

const finalStyle = computed(() => {
  return {
    minHeight: `calc(100vh - ${pagePaddingTop.value - 1}px)`,
  }
})

const tags = ref([])
const active = ref('')
const loading = ref(false)
const dataReady = computed(() => {
  return tags.value.length > 0
})
const refreshData = async () => {
  const cacheKey = 'goodsTagList'
  const res = await getCache({
    key: cacheKey
  })
  if (!res.error && res.data.value) {
    tags.value = JSON.parse(res.data.value)
    nextTick(() => {
      revertWindowScrollTop()
    })
  } else {
    loading.value = true
    getContentTagList().then((res1) => {
      if (res1.rtn_code === '0000') {
        tags.value = res1.data.tagList
        setCache({
          key: cacheKey,
          value: JSON.stringify(tags.value)
        })
      }
    }, (err) => { console.log(err) }).finally(() => {
      loading.value = false
    })
  }
}
const activeCacheKey = 'goodsTab'
watch(active, (val) => {
  setCache({
    key: activeCacheKey,
    value: val
  })
})
const tagScrollTops = new Map()
const tabsSticky = ref(false)
const beforeTabChange = () => {
  /**
   * 记录当前 tab 的滚动高度
   */
  if (tabsSticky.value) {
    tagScrollTops.set(active.value, getScrollTop())
    nextTick(() => {
      // 还原 tab 滚动高度
      const scrollTop = tagScrollTops.get(active.value)
      if (scrollTop) {
        setTimeout(() => {
          window.scrollTo(0, scrollTop + 1)
        })
      }
    })
  } else {
    tagScrollTops.delete(active.value)
  }
  return true
}
const onTabsScroll = ({ isFixed }) => {
  tabsSticky.value = isFixed
}
onMounted(async () => {
  refreshData()
  const res = await getCache({
    key: activeCacheKey
  })
  if (!res.error && res.data.value) {
    active.value = res.data.value
  }
})
</script>

<style lang="scss" scoped>
.tabs-wrapper {
  background: #f8f8f8;

  &.ready {
    padding-top: 10px;
    min-height: calc(100vh + 1px);
  }

  .loading {
    min-height: 50vh;
    padding-top: 40px;
    text-align: center;
  }
}
</style>
